import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ShowsService } from 'src/app/services/shows.service';
import { UserService } from 'src/app/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-customer-access',
  templateUrl: './admin-tool.component.html',
  styleUrl: './admin-tool.component.scss',
  standalone: false
})
export class AdminToolComponent {
  processing: boolean = false;
  error_massage: string = '';
  total_reports = 0;
  addShows!: FormGroup;
  totalShows = 0;
  totalListeners = 0;
  totalShowListeners = 0;
  loading = true;
  displayedColumns: string[] = ['show_code', 'listeners'];
  dataSource = new MatTableDataSource<any>([]);
  userUUID: string = '';
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  constructor(public showsService: ShowsService,
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AdminToolComponent>,
    private fb: FormBuilder,
    public _snakeBar: MatSnackBar
  ) {
    this.addShows = this.fb.group({
      Listeners: ['', Validators.required],
    });
    this.userUUID = data.value.UUID
    console.log('User UUID:', this.userUUID);

  }
  ngOnInit(): void {
    this.getListeners();
    this.getCustomerAccess();
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = "record per page:";
    this.dataSource.paginator = this.paginator;
  }

  getCustomerAccess() {
    this.userService.getUserShowsAvailabled(this.userUUID).subscribe((response: any) => {
      this.addShows.patchValue({
        Listeners: response.manual_listeners
      });
      this.loading = false;
      const showList = response.shows || [];
      const filteredData = showList.filter((item: any) => item.show_code);
      this.dataSource.data = filteredData;
      this.totalShows = filteredData.length;
      this.totalShowListeners =
        filteredData.reduce((acc: number, item: { listeners: any; }) => acc + Number(item.listeners || 0), 0);
      this.total_reports = filteredData.length;
      this.totalListeners = this.totalShowListeners + this.addShows.value.Listeners;
    });
  }

  billingInfo() {
    this.processing = true;
    this.error_massage = '';
    this.userService.addlistener(this.userUUID, this.addShows.value.Listeners).subscribe((response: any) => {
      this.totalListeners = this.totalShowListeners + this.addShows.value.Listeners;
      this.processing = false;
      this._snakeBar.open('Manual Listeners Count Updated Successfully!', 'Dismiss');
      setTimeout(() => {
        this._snakeBar.dismiss();
      }, 5000);
    }, (error: any) => {
      this.processing = false;
      this.error_massage = error.error.error;
      this._snakeBar.open('Error updating manual listeners. Please try again.', 'Dismiss');
      setTimeout(() => {
        this._snakeBar.dismiss();
      }, 5000);
    }
    );
  }
  getListeners() {
    this.userService.getListener(this.userUUID).subscribe((result) => {
    });
  }
}